import React from 'react';
import { useApp } from '../../context/AppContext';
import { HOME_KPIS, HOME_FEED, HOME_ACTIONS, HOME_ACTIVE_PLAYBOOKS } from '../../constants';

export default function HomeScreen() {
  const { currentUser, go, setActivePbIdx } = useApp();
  const hour = new Date().getHours();
  const greeting = hour < 12 ? 'Good morning ☀️' : hour < 17 ? 'Good afternoon 👋' : 'Good evening 🌙';

  return (
    <div style={{ flex: 1, overflowY: 'auto', height: '100%' }}>
      {/* Header */}
      <div style={{ padding: '24px 28px 0', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexShrink: 0 }}>
        <div>
          <div style={{ fontSize: '22px', fontWeight: '800', color: 'var(--navy)', fontFamily: "'DM Serif Display', serif" }}>{greeting}</div>
          <div style={{ fontSize: '13px', color: 'var(--text3)', marginTop: '3px' }}>Here's what needs your attention today, {currentUser?.name?.split(' ')[0]}</div>
        </div>
        <button
          onClick={() => { setActivePbIdx(0); go('client'); }}
          style={{ display: 'flex', alignItems: 'center', gap: '7px', padding: '9px 16px', borderRadius: '9px', background: 'var(--navy)', border: 'none', color: 'white', fontFamily: 'inherit', fontSize: '12px', fontWeight: '700', cursor: 'pointer', flexShrink: 0, marginTop: '4px' }}
        >
          <i className="ti ti-eye" style={{ fontSize: '14px', color: '#C8973A' }} />
          Preview buyer view
        </button>
      </div>

      <div style={{ padding: '20px 28px' }}>
        {/* KPI Strip */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '10px', marginBottom: '20px' }}>
          {HOME_KPIS.map((kpi, i) => (
            <div key={i} style={{ background: 'white', border: '1.5px solid var(--border)', borderRadius: '12px', padding: '14px 16px' }}>
              <div style={{ fontSize: '11px', fontWeight: '600', color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '.05em', marginBottom: '6px' }}>{kpi.label}</div>
              <div style={{ fontSize: '28px', fontWeight: '800', color: kpi.valueColor || 'var(--navy)', lineHeight: 1 }}>{kpi.value}</div>
              <div style={{ fontSize: '11px', color: kpi.changeColor, marginTop: '4px', fontWeight: '600' }}>{kpi.change}</div>
            </div>
          ))}
        </div>

        {/* Live activity + Actions */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', marginBottom: '20px' }}>
          {/* Live activity feed */}
          <div style={{ background: 'white', border: '1.5px solid var(--border)', borderRadius: '12px', overflow: 'hidden' }}>
            <div style={{ padding: '14px 16px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ fontSize: '13px', fontWeight: '700', color: 'var(--navy)', display: 'flex', alignItems: 'center', gap: '7px' }}>
                <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#22C55E', display: 'inline-block', boxShadow: '0 0 0 3px #22C55E30' }} />
                Live activity
              </div>
              <span style={{ fontSize: '10px', color: 'var(--text3)' }}>Last 24h</span>
            </div>
            <div style={{ padding: '8px 0' }}>
              {HOME_FEED.map((item, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', padding: '10px 16px', borderBottom: i < HOME_FEED.length - 1 ? '1px solid var(--border)' : undefined }}>
                  <div style={{ width: '30px', height: '30px', borderRadius: '50%', background: item.bg, color: item.color, fontSize: '10px', fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '1px' }}>{item.ini}</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '12px', fontWeight: '600', color: 'var(--navy)' }}>{item.name} <span style={{ fontWeight: '400', color: 'var(--text3)' }}>{item.action}</span></div>
                    <div style={{ fontSize: '10px', color: 'var(--text3)', marginTop: '2px' }}>{item.org} · {item.time} · {item.extra}</div>
                    <div style={{ marginTop: '6px', display: 'inline-flex', alignItems: 'center', gap: '4px', padding: '3px 8px', background: item.badgeBg, border: item.badgeBg.includes('FFFBF2') ? '1px solid var(--gold-b)' : undefined, borderRadius: '20px', fontSize: '9px', fontWeight: '700', color: item.badgeColor }}>{item.badge}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Actions queue */}
          <div style={{ background: 'white', border: '1.5px solid var(--border)', borderRadius: '12px', overflow: 'hidden' }}>
            <div style={{ padding: '14px 16px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ fontSize: '13px', fontWeight: '700', color: 'var(--navy)' }}>⚡ Actions for you</div>
              <span style={{ fontSize: '10px', padding: '2px 8px', background: '#FEF2F2', color: '#EF4444', borderRadius: '20px', fontWeight: '700' }}>3 pending</span>
            </div>
            <div style={{ padding: '8px 0' }}>
              {HOME_ACTIONS.map((action, i) => (
                <div key={i} style={{ padding: '10px 16px', borderBottom: i < HOME_ACTIONS.length - 1 ? '1px solid var(--border)' : undefined }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                    <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: action.color, flexShrink: 0 }} />
                    <div style={{ fontSize: '12px', fontWeight: '700', color: 'var(--navy)' }}>{action.title}</div>
                  </div>
                  <div style={{ fontSize: '11px', color: 'var(--text3)', marginBottom: '8px', paddingLeft: '14px' }}>{action.desc}</div>
                  <div style={{ paddingLeft: '14px', display: 'flex', gap: '6px' }}>
                    <button onClick={() => go('tracking')} style={{ padding: '5px 12px', borderRadius: '6px', background: 'var(--navy)', border: 'none', color: 'white', fontSize: '11px', fontWeight: '600', cursor: 'pointer', fontFamily: 'inherit', display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <i className="ti ti-send" /> Send nudge
                    </button>
                    <button onClick={() => go('analytics')} style={{ padding: '5px 10px', borderRadius: '6px', border: '1.5px solid var(--border2)', background: 'white', fontSize: '11px', color: 'var(--text2)', cursor: 'pointer', fontFamily: 'inherit' }}>View signals</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Active Playbooks Summary */}
        <div style={{ background: 'white', border: '1.5px solid var(--border)', borderRadius: '12px', overflow: 'hidden' }}>
          <div style={{ padding: '14px 16px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ fontSize: '13px', fontWeight: '700', color: 'var(--navy)' }}>Active Playbooks</div>
            <button onClick={() => go('admin')} style={{ fontSize: '11px', color: 'var(--gold)', fontWeight: '600', background: 'none', border: 'none', cursor: 'pointer', fontFamily: 'inherit' }}>View all →</button>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '0' }}>
            {HOME_ACTIVE_PLAYBOOKS.map((pb, i) => (
              <div key={i} style={{ padding: '14px 16px', borderRight: i < HOME_ACTIVE_PLAYBOOKS.length - 1 ? '1px solid var(--border)' : undefined }}>
                <div style={{ fontSize: '12px', fontWeight: '700', color: 'var(--navy)', marginBottom: '4px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{pb.title}</div>
                <div style={{ fontSize: '10px', color: 'var(--text3)', marginBottom: '8px' }}>{pb.contact} · {pb.org}</div>
                <div style={{ background: 'var(--surface)', borderRadius: '4px', height: '5px', marginBottom: '4px' }}>
                  <div style={{ width: `${pb.engagement}%`, height: '100%', background: pb.danger ? '#EF4444' : 'var(--gold)', borderRadius: '4px' }} />
                </div>
                <div style={{ fontSize: '10px', color: 'var(--text3)' }}>{pb.engagement}% engagement · {pb.views} views</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
